<template>
  <div class="mx-auto align-center">
    <v-chip
      v-if="isNew"
      color="warning"
      small>
      <v-icon>mdi-pencil</v-icon>
      入力待
    </v-chip>
    <v-chip
      v-else-if="isOwnProject && isApplied"
      color="primary"
      small>
      <v-icon>mdi-email-send</v-icon>
      申請中
    </v-chip>
    <v-chip
      v-else-if="isApproved"
      color="success"
      small>
      <v-icon>mdi-check</v-icon>
      承認済
    </v-chip>
    <v-chip
      v-else
      color="warning"
      small>
      <v-icon>mdi-clock</v-icon>
      承認待
    </v-chip>
    <v-icon
      v-if="project.readonly"
      small>
      mdi-lock
    </v-icon>
  </div>
</template>

<script>
export default {
  name: 'ProjectStatusBadge',
  props: {
    project: {
      type: Object,
      default: null,
    },
    checkKey: {
      type: String,
      default: 'confirmation_approved_at',
    },
  },
  computed: {
    isNew() {
      switch (this.checkKey) {
        case 'confirmation_approved_at':
          return !this.project.confirmation_created_at
        case 'written_survey_approved_at':
          return !this.project.written_survey_created_at
        case 'field_survey_approved_at':
          return !this.project.field_survey_created_at
        case 'detail_approved_at':
          return !this.project.detail_created_at
        case 'report_approved_at':
          return !this.project.report_created_at
        default:
          return false
      }
    },
    isApproved() {
      return !!this.project[this.checkKey]
    },
    isOwnProject() {
      return this.project.created_user_id === this.$store.state.auth.id
    },
    isApplied() {
      switch (this.checkKey) {
        case 'confirmation_approved_at':
          return !!this.project.confirmation_apply_status
        case 'written_survey_approved_at':
          return !!this.project.written_survey_apply_status
        case 'field_survey_approved_at':
          return !!this.project.field_survey_apply_status
        case 'report_approved_at':
          return !!this.project.report_apply_status
        default:
          return false
      }
    },
  },
}
</script>
